import React from 'react';
import "./TypedText.css";

interface TypedTextProps {
  strings: string[];
  speed?: number;
  backSpeed?: number;
  loop?: boolean;
}

const TypedText: React.FC<TypedTextProps> = ({
  strings,
  speed = 36,
  backSpeed = 20,
  loop = true,
}) => {
  const [text, setText] = React.useState('');
  const [strIdx, setStrIdx] = React.useState(0);
  const [charIdx, setCharIdx] = React.useState(0);
  const [deleting, setDeleting] = React.useState(false);

  React.useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const current = strings[strIdx];

    if (!deleting && charIdx < current.length) {
      timer = setTimeout(() => setCharIdx(c => c + 1), speed);
    } else if (deleting && charIdx > 0) {
      timer = setTimeout(() => setCharIdx(c => c - 1), backSpeed);
    } else if (!deleting && charIdx === current.length) {
      if (loop || strIdx < strings.length - 1) {
        timer = setTimeout(() => setDeleting(true), 1200);
      }
    } else if (deleting && charIdx === 0) {
      timer = setTimeout(() => {
        setDeleting(false);
        setStrIdx(i => (i + 1) % strings.length);
      }, 400);
    }

    setText(current.slice(0, charIdx));
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [charIdx, deleting, strIdx, strings, speed, backSpeed, loop]);

  return (
    <span>
      <span className='typed-text'>{text}</span>
      <span className="typed-cursor">|</span>
    </span>
  );
};

export default TypedText;
